import Vue from 'vue'

const observer = new Vue({})

export default observer
